module.exports = __webpack_public_path__ + "img/checking.ecad62b2.png";